// import { useState } from "react";
// import { MoreOutlined } from "@ant-design/icons";
// import { useQuery } from "@tanstack/react-query";
// import { Button, DatePicker, Table } from "antd";
// import type { Dayjs } from "dayjs";
// import { useForm, Controller } from "react-hook-form";
// import { journalsQueries } from "@/entities/journal";
// import {
//   JournalSectionWrapper,
//   JournalsResponsibleTable,
//   JournalSectionActions,
//   JournalSectionContent,
//   JournalSectionHeader,
//   JournalsSubscribersTable,
//   JournalSectionDescription,
//   JournalSectionFilters,
// } from "@/entities/journal/ui";
// import {
//   StatusDeclinedIcon,
//   StatusPendingIcon,
//   StatusSignedIcon,
// } from "@/shared/assets/svg/icons";
// import { useCoordinator } from "@/shared/lib/hooks";
// import { useNavigationPosition } from "@/shared/lib/hooks/use-navigate-position";
// import { IStatus } from "@/shared/ui/input-select/input-select";
import DogImg from "@shared/assets/webp/builddog.webp";
import "./journal-section-fifth.scss";
// import { InputSearch } from "@shared/ui/input-search";
// import { InputSelect } from "@shared/ui/input-select";
// import { getColumns, getDataSource } from "../../model";
// import { JournalSectionFifthInfo } from "../journal-section-info/journal-section-fifth-info";

// const STATUS_OPTIONS = [
//   { id: "NEW", status: "Новый", icon: <StatusSignedIcon /> },
//   {
//     id: "AWAITING_SIGNATURE",
//     status: "Ожидает подписания",
//     icon: <StatusPendingIcon />,
//   },
//   {
//     id: "REJECTED",
//     status: "Отклонено",
//     icon: <StatusDeclinedIcon />,
//   },
//   {
//     id: "SIGNED",
//     status: "Подписано",
//     icon: <StatusSignedIcon />,
//   },
//   {
//     id: "SENT_TO_GSN",
//     status: "Отправлено в ГСН",
//     icon: <StatusSignedIcon />,
//   },
// ] as const;

// interface IFilterForm {
//   search: string;
//   dateRange: [Dayjs | null, Dayjs | null] | null;
//   status: IStatus | null;
// }

export const JournalSectionFifth = () => {
  // const { mainJournalId } = useCoordinator();
  // const { isInJournalVersionSection } = useNavigationPosition();
  // const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  // const { handleSubmit, control } = useForm<IFilterForm>({
  //   defaultValues: {
  //     search: "",
  //     dateRange: null,
  //     status: null,
  //   },
  // });

  // const { data: mainJournalData } = useQuery(
  //   journalsQueries.getJournal({ mainJournalId }),
  // );

  // const actionsList = [
  //   { title: "asd", icon: <MoreOutlined />, onClick: () => {} },
  //   { title: "asd", icon: <MoreOutlined />, onClick: () => {} },
  // ];

  // const onSubmit = (data: IFilterForm) => {
  //   console.log("Filter data:", data);
  //   // Здесь можно добавить логику фильтрации
  // };

  return (
    <div className="journal-section-fifth-placeholder">
      <div className="journal-section-fifth-placeholder__card">
        <img width={140} height={216} src={DogImg} alt="BuildDog" />
        <div className="journal-section-fifth-placeholder__text">Скоро тут будет раздел №5</div>
      </div>
    </div>
  );

  /* TODO: раскомментировать когда раздел №5 будет готов
  return (
    <>
      <JournalsResponsibleTable
        sectionFiveId={mainJournalData?.mainJournal?.section4?.sectionId || ""}
        type="sectionFour"
      />
      <JournalsSubscribersTable
        sectionFiveId={mainJournalData?.mainJournal?.section4?.sectionId || ""}
        type="sectionFive"
      />

      <JournalSectionWrapper>
        <JournalSectionHeader actionsList={actionsList}>
          Раздел 5
        </JournalSectionHeader>
        <JournalSectionDescription>
          Перечень исполнительной документации при строительстве, реконструкции,
          капитальном ремонте объекта капитального строительства
        </JournalSectionDescription>
        {!isInJournalVersionSection && (
          <JournalSectionActions>
            <Button type="primary" onClick={handleSubmit(onSubmit)}>
              Обновить
            </Button>
          </JournalSectionActions>
        )}
        <JournalSectionFilters className="journal-section-filters--space-between">
          <Controller
            name="search"
            control={control}
            render={({ field }) => (
              <InputSearch
                style={{ width: "25%", fontSize: "12px" }}
                {...field}
              />
            )}
          />
          <div
            style={{
              display: "flex",
              gap: "16px",
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ marginRight: "8px", fontSize: "12px" }}>
              Фильтрация
            </div>
            <Controller
              name="dateRange"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <DatePicker.RangePicker
                  {...field}
                  value={value}
                  onChange={onChange}
                  format="DD.MM.YYYY"
                  placeholder={["Дата устранения от", "Дата устранения до"]}
                  style={{ maxWidth: "500px", marginRight: "8px" }}
                  allowEmpty={[true, true]}
                  allowClear
                />
              )}
            />
            <Controller
              name="status"
              control={control}
              render={({ field: { onChange, value } }) => (
                <InputSelect
                  title="Статус записи"
                  style={{ marginRight: "8px" }}
                  statuses={[...STATUS_OPTIONS]}
                  isMultiple
                  selectedStatuses={value || []}
                  setSelectedStatuses={onChange}
                />
              )}
            />
          </div>
        </JournalSectionFilters>
        <JournalSectionContent>
          <Table
            columns={getColumns({ handleView: () => setIsModalInfoOpen(true) })}
            dataSource={getDataSource()}
            pagination={{
              total: 0,
              current: 1,
              pageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              onChange: () => {},
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} из ${total} записей`,
            }}
          />
        </JournalSectionContent>
      </JournalSectionWrapper>
      {isModalInfoOpen && (
        <JournalSectionFifthInfo
          handleClose={() => setIsModalInfoOpen(false)}
        />
      )}
    </>
  );
  */
};
